import React, { useState } from 'react';
import { Phone, BookOpen } from 'lucide-react';
import { MENU, MENU_NOTE, IMAGES, RESTAURANT } from '../mock';
import MenuViewer from './MenuViewer';

export default function Menu() {
  const [viewerOpen, setViewerOpen] = useState(false);
  return (
    <section id="speisekarte" className="relative py-24 md:py-32 px-6 md:px-10 bg-[#17130f]">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="reveal max-w-3xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 bg-[rgba(224,180,159,0.6)]" />
            <span className="eyebrow">03 — Speisekarte</span>
          </div>
          <h2 className="font-serif-display font-medium text-[#f2ebe3] text-4xl md:text-6xl leading-[1.05]">
            Unsere <span className="italic text-[#e0b49f]">Lieblinge</span> der Küche.
          </h2>
          <p className="mt-6 text-[#c3b7aa] text-lg font-light leading-relaxed">
            Ein kleiner Auszug – die komplette Speisekarte mit allen Gerichten, Weinen &amp; Getränken finden Sie hier zum Durchblättern.
          </p>
          <button
            onClick={() => setViewerOpen(true)}
            className="mt-7 inline-flex items-center gap-2.5 bg-[#e0b49f] text-[#1a1410] px-7 py-3.5 rounded-full font-medium hover:bg-[#eac6b3] transition-colors duration-300 shadow-lg shadow-black/20"
          >
            <BookOpen size={17} /> Komplette Speisekarte ansehen
          </button>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-[0.85fr_1.6fr] gap-10 lg:gap-16 items-start">
          {/* Sticky takeaway card */}
          <div className="reveal lg:sticky lg:top-28">
            <button
              onClick={() => setViewerOpen(true)}
              className="group relative block w-full img-zoom rounded-2xl overflow-hidden h-[300px] md:h-[380px] mb-6 text-left"
            >
              <img src="/speisekarte/seite-1.png" alt="Speisekarte Restaurant Alfa" className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
              <span className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
                <span className="font-serif-display text-xl text-[#f6f0e9]">Speisekarte durchblättern</span>
                <span className="flex items-center justify-center h-10 w-10 rounded-full bg-[#e0b49f] text-[#1a1410] group-hover:scale-110 transition-transform duration-300">
                  <BookOpen size={17} />
                </span>
              </span>
            </button>
            <div className="rounded-2xl border border-[rgba(224,180,159,0.2)] bg-[#1c1712] p-8">
              <h3 className="font-serif-display text-2xl text-[#f2ebe3]">Am besten reservieren</h3>
              <p className="mt-3 text-[#a99a8b] text-sm leading-relaxed">
                Genießen Sie unsere Küche vor Ort. Sichern Sie sich Ihren Tisch telefonisch oder über Facebook.
              </p>
              <a
                href={RESTAURANT.phoneHref}
                className="mt-6 inline-flex items-center gap-2.5 bg-[#e0b49f] text-[#1a1410] px-6 py-3 rounded-full font-medium hover:bg-[#eac6b3] transition-colors duration-300"
              >
                <Phone size={16} /> Tisch reservieren
              </a>
            </div>
          </div>

          {/* Menu categories */}
          <div className="space-y-14">
            {MENU.map((cat) => (
              <div key={cat.category} className="reveal">
                <div className="flex items-center gap-4 mb-7">
                  <h3 className="font-serif-display text-3xl md:text-4xl text-[#e0b49f] italic">{cat.category}</h3>
                  <span className="flex-1 h-px bg-[rgba(224,180,159,0.18)]" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-7">
                  {cat.items.map((item, i) => (
                    <div key={i} className="group">
                      <div className="flex items-baseline gap-3">
                        <span className="font-sans-body font-medium text-[#f2ebe3] text-lg group-hover:text-[#e0b49f] transition-colors duration-300">
                          {item.name}
                        </span>
                        <span className="flex-1 border-b border-dotted border-[rgba(224,180,159,0.25)] translate-y-[-4px]" />
                        <span className="font-serif-display text-[#e0b49f] text-lg whitespace-nowrap">{item.price}</span>
                      </div>
                      <p className="mt-1.5 text-[#a99a8b] text-sm leading-snug pr-6">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <p className="reveal text-[#8a7d70] text-xs leading-relaxed border-t border-[rgba(224,180,159,0.15)] pt-6">
              {MENU_NOTE}
            </p>
          </div>
        </div>
      </div>

      <MenuViewer open={viewerOpen} onClose={() => setViewerOpen(false)} />
    </section>
  );
}
